import React from 'react';
import Header from './components/Shared/Header';
import Footer from './components/Shared/Footer';
import { ContentWr } from './styles/textTags';
import { Route, Routes } from 'react-router-dom';
import LeftLooper from './components/Loopers/LeftLooper';
import RightLooper from './components/Loopers/RightLooper';
import Main from './pages/Main';
import Event from './pages/Event';
import styled from 'styled-components';

function App() {
  return (
    <StyledApp className='App'>
      <Header />
      <ContentWr>
        <LeftLooper />
        <RightLooper />
        <main>
          <Routes>
            <Route index element={<Main />} />
            <Route path='/event/:slug' element={<Event />} />
          </Routes>
        </main>
      </ContentWr>
      <Footer />
    </StyledApp>
  );
}

const StyledApp = styled.div`
  min-height: 100vw;
  min-height: 100svh;
  display: flex;
  flex-direction: column;
`;

export default App;
